import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "paymentFilters",
  initialState: {},
  reducers: {
    setPaymentFilters(
      state: Record<string, unknown>,
      action: PayloadAction<Partial<Record<string, unknown>>>,
    ): void {
      Object.assign(state, action.payload);
    },
    updatePaymentFilters(
      state: Record<string, unknown>,
      action: PayloadAction<{ key: string; value: unknown }>,
    ): void {
      const { key, value } = action.payload;
      // eslint-disable-next-line no-param-reassign
      (state as Record<string, unknown>)[key] = value;
    },
    resetPaymentFilters() {
      // eslint-disable-next-line no-param-reassign, no-unused-vars, @typescript-eslint/no-unused-vars
      return {};
    },
  },
});

export const { setPaymentFilters, updatePaymentFilters, resetPaymentFilters } =
  slice.actions;
export const { reducer } = slice;

export default slice;
